import { useState } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import permissions from 'common/system-permissions'
import usePermissions from 'common/use-permissions'

import DashTable from './DashTable'

import ContentManagementProvider from 'routes/content-management/ContentManagement/ContentManagementProvider'
import CreateContentModal from '../CreateContentModal'
import { ContentType } from 'routes/content-management/ContentManagement/ContentManagementProvider/Context'

interface ContentTableProps extends RouteComponentProps {
  contentType: {
    label: string
    context: string
  }
  data: {
    all: Array<{ name: string; count: number; content_item_count: number }>
    reached: Array<{ name: string; count: number; content_item_count: number }>
    not_reached: Array<{ name: string; count: number; content_item_count: number }>
  }
  error: boolean
  loading: boolean
  nameLabel: string
  tableName: string
}

export const ContentTable = ({
  contentType,
  data,
  error,
  history,
  loading,
  nameLabel,
  tableName,
}: ContentTableProps) => {
  const [contentName, setContentName] = useState('')
  const [openContentModal, setOpenContentModal] = useState(false)

  const handleClose = () => setOpenContentModal(false)

  const canCreateContent = usePermissions(permissions.MANAGE_COLLEGE_CONTENT)

  const actions = () => {
    const a = [
      {
        label: 'View Content',
        onClick: () => history.push(`${import.meta.env.BASE_URL}/engage/presence`),
      },
    ]
    if (canCreateContent) {
      return [
        {
          label: 'Create Content',
          onClick: (row: { name: string }) => {
            setContentName(row.name)
            setOpenContentModal(true)
          },
        },
        ...a,
      ]
    }
    return a
  }

  return (
    <>
      <ContentManagementProvider>
        <CreateContentModal
          show={openContentModal}
          onHide={handleClose}
          contentItem={{ [contentType.label]: [contentName] }}
          contextType={contentType.context as ContentType}
        />
      </ContentManagementProvider>
      <DashTable
        tableName={tableName}
        columns={[
          { id: 'name', label: nameLabel, enableSort: false, header: true },
          {
            id: 'count',
            label: 'Students',
            enableSort: true,
            align: 'right',
            format: (value) => value.toLocaleString(),
          },
          {
            id: 'content_item_count',
            label: 'Content',
            enableSort: true,
            align: 'right',
            format: (value) => (value ? value.toLocaleString() : 0),
          },
        ]}
        groups={[
          { id: 'all', label: 'All Students', rows: data.all },
          { id: 'reached', label: 'Reached Students', rows: data.reached },
          { id: 'not_reached', label: 'Not Reached Students', rows: data.not_reached },
        ]}
        actions={actions()}
        defaultFilter="reached"
        loading={loading}
        error={error}
      />
    </>
  )
}

export default withRouter(ContentTable)
